export default __webpack_public_path__ + "static/media/Saurashtre-Somnatham.c86bc7c0.ogg";